module.exports = __webpack_public_path__ + "assets/img/20.0777e05e.png";